<mat-select
  [ngModel]="value"
  [disabled]="disabled"
  [placeholder]="placeholder"
  (selectionChange)="onSelected($event)"
>
  <input
    type="text"
    [formControl]="searchControl"
    #inputSearch
    class="search-select"
    (keydown)="$event.stopPropagation()"
    [placeholder]="'common.search' | t"
  />
  <mat-option *ngIf="!required" [value]="null">None</mat-option>
  <ng-container *ngFor="let option of options; trackBy: trackUser">
    <mat-option [value]="option.id">
      <span class="text" [title]="option.fullName">{{ option.fullName }}</span>
      <span class="text muted-text" [title]="option?.email">
        {{ option?.email }}
      </span>
      <span class="text muted-text text-last-active">
        <sn-user-last-active
          [user]="option"
          [prefix]="('common.lastActive' | t) + ': '"
          dateFormat="mediumDate"
        ></sn-user-last-active>
      </span>
    </mat-option>
  </ng-container>
  <mat-progress-bar
    *ngIf="isLoading"
    [color]="'accent'"
    [mode]="'indeterminate'"
  ></mat-progress-bar>
</mat-select>
